import {useMemo} from 'react';
import {TrilhaStatus} from 'domain/usecases';
import {PortalTimelineData} from 'presentation/components/Timeline/types';
import {formatToCapitalizeWithExceptions} from 'presentation/utils/formatToCapitalizeWithExceptions';
import {formatDateString} from 'presentation/utils';
import {DateFormatEnum} from 'presentation/constants';

export function useAuthStatusDrawerData(trilhaStatus: TrilhaStatus[]) {
	const exceptions: string[] = ['Junta Medica', 'Auditoria Medica'];

	const timelineData = useMemo<PortalTimelineData[]>(
		() =>
			trilhaStatus.map(item => ({
				title: formatToCapitalizeWithExceptions(item.dsTrilha, exceptions),
				description: formatDateString(
					item.dtRegistro,
					DateFormatEnum.DATE_FORMAT_7,
					DateFormatEnum.DATE_FORMAT_8,
				),
			})),
		[trilhaStatus],
	);

	const lastUpdate = timelineData[0]?.description || '';

	return {timelineData, lastUpdate};
}
